import axios from "./axios-instance"
import store from "@/store"

export default {
  getOne: pdfId => axios(store)({
    url: `/api/pdf/${pdfId}`,
    method: "GET",
    responseType: "arraybuffer",
  })
    .then(response => response.data
      //Create a Blob from the PDF Stream
      // new Blob([response.data], { type: "application/pdf;base64" })
    ),
}
